<!-- IVD content -->
<ng-content *ngIf="!(currentUserCanRuo$ | async)" select="[IVD]"></ng-content>

<!-- RUO content -->
<ng-content *ngIf="currentUserCanRuo$ | async" select="[RUO]"></ng-content>
